import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { STEP_STATUS, STEP_STATUS_ICON } from '../constants';
import css from './AgentActivity.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.AGENT_ACTIVITY';

const StepStatusIcon = ({ status }) => {
    const iconConfig = STEP_STATUS_ICON[status];
    if (!iconConfig) return null;
    return (
        <Icon
            name={iconConfig.name}
            size={IconSizes.X_SMALL}
            variant={iconConfig.variant}
            className={classNames(css.historyStatusIcon, { [css.spinner]: iconConfig.isSpinning })}
        />
    );
};

StepStatusIcon.propTypes = {
    status: PropTypes.oneOf(Object.values(STEP_STATUS)),
};

const groupConsecutiveSteps = steps => {
    const groups = [];
    for (const step of steps) {
        const last = groups[groups.length - 1];
        if (last && (last.title ?? '') === (step.title ?? '')) {
            last.count += 1;
            last.latest = step;
        } else {
            groups.push({ title: step.title, firstStep: step, latest: step, count: 1 });
        }
    }
    return groups;
};

const AgentActivityHistoryList = ({ steps }) => {
    const groups = groupConsecutiveSteps(steps);
    return (
        <div className={css.historyList} role="list">
            {groups.map((group, index) => (
                <div
                    className={css.historyRow}
                    role="listitem"
                    key={group.firstStep.step_id ? `step-${group.firstStep.step_id}` : `idx-${index}`}
                >
                    <span className={css.historyDotWrap} aria-hidden="true">
                        <span className={css.historyDot} />
                        <span className={css.historyConnector} />
                    </span>
                    <span className={css.historyName}>
                        {group.title || (
                            <Translate id={`${TRANSLATION_PREFIX}.STEP_FALLBACK`} data={{ index: index + 1 }} />
                        )}
                        {group.count > 1 && (
                            <span className={css.historyCount}>
                                <Translate id={`${TRANSLATION_PREFIX}.STEP_COUNT`} data={{ count: group.count }} />
                            </span>
                        )}
                    </span>
                    <StepStatusIcon status={group.latest.status} />
                </div>
            ))}
        </div>
    );
};

AgentActivityHistoryList.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            step_id: PropTypes.string,
            title: PropTypes.string,
            status: PropTypes.oneOf(Object.values(STEP_STATUS)),
        })
    ).isRequired,
};

export default AgentActivityHistoryList;
